import { Hammer } from 'lucide-react';
import { Gavel } from 'lucide-react';
import { Images } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

export default class FeatureOne extends React.Component {
    render(){
        return (
            <>
                <section className="feature-one-sec">
                    <div className="container">
                        <div className="row">
                            {/* Start Feature One Single */}
                            <div className="col-xl-6 col-lg-6">
                                <div className="feature-one__single">
                                    <div className="shape1"></div>
                                    <div className="feature-one__single-inner">
                                        <div className="feature-one__single-icon">
                                            <Gavel size={42} />
                                        </div>

                                        <div className="feature-one__single-text">
                                            <h2><Link to={ `/`}>Our Services</Link></h2>
                                            <p> Variety of services: custom builds to detailed restorations with quality and precision.</p>
                                            <div className="feature-one__single-btn">
                                                <Link to={ `/services`}>View Our Services<i className="icon-right-arrow-1"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature One Single */}

                            {/* Start Feature One Single */}
                            <div className="col-xl-6m col-lg-6">
                                <div className="feature-one__single">
                                    <div className="shape1"></div>
                                    <div className="feature-one__single-inner">
                                        <div className="feature-one__single-icon">
                                            <Images size={42} />
                                        </div>

                                        <div className="feature-one__single-text">
                                            <h2><Link to={ `/`}>Our Portfolio</Link></h2>
                                            <p>Our projects: visions to reality, reflecting excellence and satisfaction.</p>
                                            <div className="feature-one__single-btn">
                                                <Link to={ `/portfolio`}>View Our Projects<i className="icon-right-arrow-1"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature One Single */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}